import { sql } from "drizzle-orm";
import {
  index,
  pgTable,
  text,
  timestamp,
  uniqueIndex,
  uuid,
  check,
} from "drizzle-orm/pg-core";
import { pages, pageVersions } from "./page-builder";

const tz = { withTimezone: true } as const;

export const SCHEDULED_PUBLISH_STATUSES = [
  "pending",
  "publishing",
  "published",
  "cancelled",
  "failed",
] as const;

export type ScheduledPublishStatus =
  (typeof SCHEDULED_PUBLISH_STATUSES)[number];

export const scheduledPublishes = pgTable(
  "scheduled_publishes",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    pageId: uuid("page_id")
      .notNull()
      .references(() => pages.id, { onDelete: "cascade" }),
    versionId: uuid("version_id")
      .notNull()
      .references(() => pageVersions.id, { onDelete: "cascade" }),
    publishAt: timestamp("publish_at", tz).notNull(),
    status: text("status").notNull().default("pending"),
    createdBy: text("created_by").notNull(),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    publishedAt: timestamp("published_at", tz),
    error: text("error"),
  },
  (table) => [
    index("idx_scheduled_publishes_pending")
      .on(table.tenantId, table.publishAt)
      .where(sql`${table.status} = 'pending'`),
    index("idx_scheduled_publishes_page").on(table.tenantId, table.pageId),
    index("idx_scheduled_publishes_tenant_status").on(
      table.tenantId,
      table.status,
    ),
    uniqueIndex("uq_scheduled_publishes_active_page")
      .on(table.tenantId, table.pageId)
      .where(sql`${table.status} IN ('pending', 'publishing')`),
    check(
      "chk_scheduled_publishes_status",
      sql`${table.status} IN ('pending', 'publishing', 'published', 'cancelled', 'failed')`,
    ),
  ],
);
